import { render, staticRenderFns } from "./i-image-viewer.vue?vue&type=template&id=df21d7d4&scoped=true&"
import script from "./i-image-viewer.vue?vue&type=script&lang=js&"
export * from "./i-image-viewer.vue?vue&type=script&lang=js&"
import style0 from "./i-image-viewer.vue?vue&type=style&index=0&id=df21d7d4&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df21d7d4",
  null
  
)

export default component.exports